import React, { useEffect, useRef } from 'react'
import Link from 'next/link'
import { ImgResponsive } from '@/components/elements'
import { FaArrowRight } from 'react-icons/fa6'
import { StylePortfolioGridItem } from './style'
import { gsap } from 'gsap'

interface PortfolioGridItemProps {
  categories: string[] | string
  categoriesKey: string[] | string
  title: string
  portfolioImg?: string
  noLink?: boolean
  portBgColor?: string
  slug?: string
}

const PortfolioGridItem = (props: PortfolioGridItemProps) => {
  const { categories, categoriesKey, title, portfolioImg, noLink, portBgColor, slug } = props
  const itemRef = useRef<HTMLDivElement>(null)
  const cateName = Object.values(categories).filter((cate) => cate.toLowerCase() !== 'portfolio')

  useEffect(() => {
    gsap.set(itemRef.current, { opacity: 0, y: 20 })
    gsap.to(itemRef.current, { opacity: 1, y: 0, duration: 0.5, delay: 0.2 })
  }, [])

  return (
    <StylePortfolioGridItem
      ref={itemRef}
      className={`box p-4 md:p-8 ${(Array.isArray(categoriesKey)
        ? categoriesKey.join(' ')
        : categoriesKey
      )
        .toString()
        .replace(',', ' ')}`}
      portBg={portBgColor}
    >
      <div className='flex h-full flex-col space-y-4'>
        {portfolioImg ? (
          <div className='grow'>
            <ImgResponsive
              src={portfolioImg}
              alt={title}
              width={355}
              height={250}
              PicClassName='flex justify-center items-end h-full'
            />
          </div>
        ) : null}
        <div className='content text-center'>
          <h3 className='text-xl'>{title}</h3>
          <p className='small uppercase tracking-[7.15px]'>{cateName.join(', ')}</p>
        </div>
        {noLink ? (
          <div className='flex-none'>&nbsp;</div>
        ) : (
          <div className='flex flex-none justify-end'>
            <Link href={`/portfolio/${slug}`} legacyBehavior prefetch={false}>
              <a className='service-readmore text-black'>
                <FaArrowRight size={14} />
              </a>
            </Link>
          </div>
        )}
      </div>
    </StylePortfolioGridItem>
  )
}

export default PortfolioGridItem
